import React, { useState } from "react";
import MembershipPopup from "./MembershipPopup";

export default function ExclusiveSection() {
  const [showPopup, setShowPopup] = useState(false);
  const [accessGranted, setAccessGranted] = useState(false);

  return (
    <div style={{ margin: "50px 0", textAlign: "center" }}>
      <div style={{
        position: "relative",
        // width: "800px",
        height: "50px",
        margin: "0 auto"
      }}>
        {/* Hidden blurred content */}
        <div style={{
          width: "100%",
          height: "100%",
          background: "#ff6b00",
          color: "#000",
          filter: accessGranted ? "none" : "blur(100px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "12px",
          transition: "filter 0.3s"
        }}>
          <p>{accessGranted ? "🎉 Exclusive Degen Den Content!" : "Hidden Content"}</p>
        </div>

        {/* Button overlay */}
        {!accessGranted && (
          <div style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }}>
            <button
              onClick={() => setShowPopup(true)}
              style={{
                padding: "10px 20px",
                background: "#111",
                color: "#0f0",
                border: "1px solid #0f0",
                cursor: "pointer",
                fontWeight: "bold"
              }}
            >
              Degen Den Academy Member?
            </button>
          </div>
        )}
      </div>

      {showPopup && (
        <MembershipPopup
          onClose={() => setShowPopup(false)}
          onAccessGranted={() => {
            setAccessGranted(true);
            setShowPopup(false);
          }}
        />
      )}
    </div>
  );
}
